import { useQuery } from 'react-query';
import TransApi from '../../../../services/trans/trans';
import quickbuyApi from "../../../../services/quickbuyApi";

let cartapi = new TransApi();
let brokerapi = new quickbuyApi()

const getFolioList = async () => {
    let payload = {
        "apiName": "getFolioList",
        "body": {}
    };
    let cartData = await cartapi.common(payload)
    const originalArray = cartData?.data?.data;
    const newArray = await originalArray?.map(item => ({
        schemename: item?.schemename,
        value: item?.foliono,
        holdingMode: item?.holdingMode,
        plancode: item?.plancode,
        planname: item?.planname,
        optioncode: item?.optioncode,
        optionname: item?.optionname,
        stopAccount: item?.stopAccount,
        dematAccount: item?.dematAccount,
        stopPayment: item?.stopPayment,
        schemecode: item?.schemecode,
        groupcode: item?.groupcode,
        label: item?.foliono,
        accounttype: item?.accounttype,
        holderName: item?.holderName,
        jointHolderName: item?.jointHolderName,
        secHolderPan: item?.secHolderPan,
        secHolderName: item?.secHolderName,
        secHolderEmail: item?.secHolderEmail,
        secHolderMobile: item?.secHolderMobile,
        thHolderName: item?.thHolderName,
        thHolderPan: item?.thHolderPan,
        thHolderEmail: item?.thHolderEmail,
        thHolderMobile: item?.thHolderMobile,
        arnCode: item?.arnCode,
        subBrokerCode: item?.subBrokerCode,
        riaCode: item?.riaCode,
        internalCode: item?.internalCode,
        euinNo: item?.euinNo,
        stopAccountReason: item?.stopAccountReason,
        stopPaymentReason: item?.stopPaymentReason,
        guardianName: item?.guardianName,
        invCategory: item?.invCategory,
    }));

    return newArray || [];
}

const getAllBrokerListData = async (folioNo, planType = '') => {
    if (folioNo !== '') {
        const request = {
            apiName: "folioBrokerList",
            body: {
                folioNo: folioNo,
                planType: planType
            },
        };

        try {
            const brokerData = await brokerapi.folioBrokerList(request);
            if (brokerData?.data?.success) {
                const finalArray = [];
                const arnAry = brokerData?.data?.data?.filter(item => item.brokerCode?.toUpperCase().startsWith("ARN-"));
                arnAry?.map(item => {
                    item.label = item.brokerCode;
                    item.value = item.brokerCode;
                })
                finalArray.Arnarray = removeDuplicates(arnAry, 'value');

                const riaAry = brokerData?.data?.data?.filter(item => item.brokerCode?.toUpperCase().startsWith("INA") || item.brokerCode?.toUpperCase().startsWith("INZ"))
                riaAry?.map(item => {
                    item.label = item.brokerCode;
                    item.value = item.brokerCode;
                })
                finalArray.riaArray = removeDuplicates(riaAry, 'value');

                if (arnAry.length > 0) {
                    finalArray.defaultArn = arnAry[0].value;
                }
                if (riaAry.length > 0) {
                    finalArray.defaultRia = riaAry[0]?.brokerCode;
                }

                console.log('finalArray', finalArray);
                return finalArray
            } else {
                return []
            }
        } catch (e) {
            return []
        }
    }
}

const removeDuplicates = (arr, key) => { return arr.filter((item, index, self) => index === self.findIndex((t) => t[key] === item[key])); };

const getNFOStartDet = async (schemeCode) => {

    let payload = {
        "apiName": "frequency",
        "params": `?SchemeID=${schemeCode}&Frequency=All&TrType=SIP`
    };

    let freqResp = await cartapi.commonGet(payload);
    if (freqResp?.data?.success) {
        if (freqResp?.data?.data?.length > 0) {
            let shortBlast = {};
            let fresData = {};
            let freqArray = [];
            let dummyArray = [];
            let miniAmtArray = {}
            freqResp?.data?.data.map((curr, index) => {
                let currFrequncy = curr.frequency.toLowerCase();
                let currFrequncylabel = curr.frequency;
                if (currFrequncy === 'annual') {
                    currFrequncy = 'annually'
                } else if (currFrequncy === 'fortnightly') {
                    currFrequncy = 'fournightly'
                }

                if (dummyArray.indexOf(currFrequncy) === -1) {
                    dummyArray.push(currFrequncy);
                    freqArray.push({ "label": currFrequncylabel, "value": currFrequncy })
                }
                // curr.nfosipDate = '2024-07-23'

                if (curr.minNoOfInstalments == 6) {
                    shortBlast[currFrequncy] = curr;
                } else {
                    fresData[currFrequncy] = curr;
                    miniAmtArray[currFrequncy] = curr?.minAmount;
                }
            })

            let obj = {
                //  blast: shortBlast,
                nonblast: fresData,
                frequency: freqArray,
                miniAmtArray: miniAmtArray
            }
            return obj

        }

    }
    return [];
}

export const useNFOStartDet = (schemeCode) => {
    // console.log("useNFOStartDet", schemeCode)

    return useQuery(['nfoStartDet', schemeCode], () => getNFOStartDet(schemeCode),
        {
            enabled: !!schemeCode,
            staleTime: 60000 * 10 //10minutes
        });
}

export const useFolioDet = () => {
    console.log("foliodet")
    return useQuery(['foliodet'], () => getFolioList(),
        {
            staleTime: 60000 * 10  //10minutes
        });
}

export const useBrokerData = (folioNo, planType) => {
    const ptype = planType && planType === 'regular' ? 'R' : 'D';
    console.log("brokerdata", ptype)
    return useQuery(['brokerdata', folioNo, ptype], () => getAllBrokerListData(folioNo, ptype),
        {
            // staleTime: 1000000 //10minutes
        }
    );
}